import { mediaQuery, RESPONSIVE_PADDING } from 'constants/ui';

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: RESPONSIVE_PADDING.DESKTOP,
  paddingBottom: RESPONSIVE_PADDING.MOBILE,
  overflow: 'auto',

  [mediaQuery.desktop]: {
    maxHeight: 'calc(100vh - 100px)',
  },

  [mediaQuery.mobileAndTablet]: {
    gap: RESPONSIVE_PADDING.TABLET,
  },
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: `${RESPONSIVE_PADDING.DESKTOP} ${RESPONSIVE_PADDING.MOBILE} 0`,
};

export const headerTitleWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const panelContentStyles = {
  flex: 1,
  overflow: 'auto',
};
